import { FC } from 'react'
import { PageTitle } from '../../_metronic/layout/core'
import { Dashboard } from '../modules/Dashboard/Dashboard'


const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Inicio</PageTitle>
      <Dashboard/>
    </>
  )
}

export { DashboardWrapper }
